//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { Collapse, CollapseProps } from '@mui/material';

type TableCollapseProps = {
  isCollapsed: boolean;
  children: React.ReactNode;
} & CollapseProps;

const TableCollapse = ({ isCollapsed, children, ...props }: TableCollapseProps) => {
  return (
    <Collapse in={!isCollapsed} timeout={200} unmountOnExit {...props}>
      {children}
    </Collapse>
  );
};

export default TableCollapse;
